export const DefaultRequiredFields = [
  {
    type: 0,
    enabled: false,
  },
  {
    type: 1,
    enabled: false,
  },
  {
    type: 2,
    enabled: false,
  },
  {
    type: 3,
    enabled: false,
  },
  {
    type: 4,
    enabled: false,
  },
  {
    type: 5,
    enabled: false,
  },
  {
    type: 6,
    enabled: false,
  },
];

export class ActionNames {
  0 = 'Invitation Message';
  1 = 'Send Reminder';
}

export const DefaultActions = [
  {
    type: 0,
    enabled: true,
    dismissible: true,
    message: '',
    millis_after_entering: 0,
  },
  {
    type: 1,
    enabled: true,
    dismissible: true,
    message: '',
    millis_after_entering: 172800000,
  },
];

export const questionsNames = {};

export const RequiredFieldsNames = {
  0: 'process_cv',
  1: 'process_phone',
  2: 'process_bio',
  3: 'process_experience',
  4: 'process_education',
  5: 'process_picture',
  6: 'process__pitch',
};

export const StepsNames = {
  0: 'process_application',
  1: 'process_hired',
  2: 'process_offer',
  3: 'process_interview',
  4: 'process_one_way_qualified',
  5: 'process_rejected',
  6: 'process_waitlist',
};
